mutation UploadUserTopicMaterial($input: UploadMaterialInput!) {
  uploadUserTopicMaterial(input: $input) {
    id
    url
    previewFile {
      id
      url
      name
    }
    displayName
    type
    assetType
    createdAt
  }
}

# Input type reference (not part of the query):
# input UploadMaterialInput {
#   file: Upload!
#   topicId: ID!
#   previewFile: Upload!
#   companyId: ID
#   materialId: ID!
#   assetType: AssetType
# }
